import { app } from '../../../bootstrap/core';
import { documentListComponent } from './documentList.component';
import { InboxJobService } from '../inbox.job.service';
import { InboxDocumentService } from '../inbox.document.service';
import { InboxTabs } from '../inbox.constants';

app.component('documentList', documentListComponent)
  .constant('InboxTabs', InboxTabs)
  .service('jobService', InboxJobService)
  .service('inboxDocumentService', InboxDocumentService);




